import { CheckCircleIcon } from "@phosphor-icons/react/ssr";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import ValueComparisonTable from "~/componentsDS/ValueComparisonTable";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";

import {
    BODYMATCHED_ALTERNATIVES_COMPARISON_ROWS,
    BODYMATCHED_TOTAL_VALUE_ROWS,
} from "./comparisonData";

const BODYMATCHED_HIGHLIGHTS = [
    "One prescription cream",
    "Fewer steps",
    "Fewer products",
    "Lower long-term cost",
    "Hormone-informed skin care",
];

const BodymatchedTotalValueContent = () => (
    <div className="text-primary500">
        <Paragraph size="xl" sizes={{ md: "2xl" }} className="mb-2 max-md:font-medium">
            Why <TextWithRegisteredMark text="BodyMatched®" /> Is Different
        </Paragraph>
        <Paragraph size="lg" className="mb-[32px]">
            <TextWithRegisteredMark text="BodyMatched®" /> combines prescription-strength dermatologic actives + hormone-informed
            care in a single formulation — something no over-the-counter skincare can replicate.
        </Paragraph>

        <Paragraph size="xl" sizes={{ md: "2xl" }} className="mb-2 max-md:font-medium">
            What Women Often Use Instead
        </Paragraph>
        <Paragraph size="lg" className="mb-4">
            To approximate the same <br className="md:hidden"/> results, many women use:
        </Paragraph>

        <ValueComparisonTable rows={BODYMATCHED_ALTERNATIVES_COMPARISON_ROWS} className="mb-[32px]" />

        <Paragraph size="xl" sizes={{ md: "2xl" }} className="mb-4 max-md:font-medium">
            <TextWithRegisteredMark text="BodyMatched®" /> Total Value
        </Paragraph>

        <ValueComparisonTable rows={BODYMATCHED_TOTAL_VALUE_ROWS} />

        <ul className="mt-4 flex flex-col gap-4">
            {BODYMATCHED_HIGHLIGHTS.map((item) => (
                <li key={item} className="flex items-center gap-1">
                    <CheckCircleIcon size={20} weight="fill" className="shrink-0 text-primary500" />
                    <Paragraph size="lg">{item}</Paragraph>
                </li>
            ))}
        </ul>
    </div>
);

export default BodymatchedTotalValueContent;
